import React from "react";

const SearchSkeleton = () => {
  return (
    <section className="bg-black min-h-screen pt-24">
      <div className="padding pt-8">
        {/* Search Header Skeleton */}
        <div className="mb-8">
          <div className="h-8 bg-gray/30 rounded-lg w-64 backdrop-blur-sm overflow-hidden relative mb-4">
            <div className="absolute inset-0 bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
          </div>
        </div>

        {/* Results Grid Skeleton */}
        <div className="grid lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 gap-4 md:gap-6">
          {Array.from({ length: 12 }).map((_, index) => (
            <div
              key={index}
              className="relative overflow-hidden rounded-lg bg-gray/20 backdrop-blur-sm border border-white/10 movie-card-wrapper"
            >
              {/* Poster Skeleton */}
              <div className="relative aspect-[2/3] overflow-hidden bg-gradient-to-br from-gray/30 via-gray/20 to-gray/30">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer"></div>
                <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/40"></div>
              </div>

              {/* Info Skeleton */}
              <div className="p-3 space-y-2">
                <div className="h-4 bg-gray/40 rounded-md w-3/4 backdrop-blur-sm">
                  <div className="h-full bg-gradient-to-r from-gray/40 via-white/10 to-gray/40 animate-shimmer"></div>
                </div>
                <div className="h-3 bg-gray/30 rounded-md w-1/2 backdrop-blur-sm">
                  <div className="h-full bg-gradient-to-r from-gray/30 via-white/10 to-gray/30 animate-shimmer"></div>
                </div>
              </div>

              {/* Rating Badge Skeleton */}
              <div className="absolute top-3 right-3 bg-black/50 backdrop-blur-md rounded-full px-2.5 py-1 border border-white/10">
                <div className="h-3 w-8 bg-gray/40 rounded-full">
                  <div className="h-full bg-gradient-to-r from-gray/40 via-white/10 to-gray/40 rounded-full animate-shimmer"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SearchSkeleton;

